import { useEffect } from 'react';

const SITE_NAME = 'FM Ultratech Farms';

/**
 * Set page title and meta description for SEO.
 * Use in each page component to set a unique title and description for search engines.
 *
 * @param {string} title - Page title (e.g. "Products"). Will be shown as "Products | FM Ultratech Farms".
 * @param {string} [description] - Meta description for search results (recommended 150–160 chars).
 */
export default function PageMeta({ title, description }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    document.title = fullTitle;

    let meta = document.querySelector('meta[name="description"]');
    if (description) {
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', 'description');
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', description);
    } else if (meta) {
      meta.setAttribute('content', '');
    }
  }, [title, description]);

  return null;
}

export { SITE_NAME };
